/**
 * One resolver for the display name of a `fileTemplates` document.
 *
 * The corpus carries TWO naming conventions and always has: admin-portal-created
 * templates store `templateName`, every factory-created template stores `name`
 * (services/admin-functions/src/templates/factories/*.ts). A surface that reads
 * only `templateName` renders blank titles, "Unknown Template" groups, or throws
 * in a `localeCompare` comparator on every factory-seeded tenant.
 *
 * `getLoanBooks.ts` already resolves it correctly server-side; this is the same
 * chain for the client surfaces.
 */

export const UNKNOWN_TEMPLATE_NAME = 'Unknown Template';

/** The subset of a fileTemplates doc that carries a name. All fields optional. */
export interface TemplateNameFields {
  /** Admin-portal-created templates. */
  templateName?: string | null;
  /** Factory-created templates (Finsure, WLTH, Orde, Entors, AFG, ...). */
  name?: string | null;
  /** The document id, used as the last legible fallback. */
  id?: string | null;
}

/**
 * `templateName` -> `name` -> document id -> 'Unknown Template'.
 * Never returns an empty string, so it is safe as a comparator key and as a
 * React text child.
 */
export function resolveTemplateDisplayName(template: TemplateNameFields): string {
  return template.templateName || template.name || template.id || UNKNOWN_TEMPLATE_NAME;
}
